function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext, forwardRef } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { ThemeContext } from 'grommet';
import { useFormikContext } from 'formik';
import styled from 'styled-components';
import PropTypes from 'prop-types';
const StyledInput = styled(CurrencyInput)`
  box-sizing: border-box;
  font-size: 12px;
  font-family: inherit;
  -webkit-appearance: none;
  color: inherit;
  width: 100%;
  padding: 9px 4px;
  font-weight: 400;
  margin: 0;
  border-radius: 4px;
  font-size: 12px;
  height: 38px;
  border: 1px solid ${props => props.theme.global.colors['border']};
  &:focus {
    outline: none;
    box-shadow: 0 0 2px 2px ${props => props.theme.global.colors['brand']};
  }
  background: ${({
  theme
}) => theme.textInput.extend.background};
  ${props => props.disabled && `opacity: ${props.theme.textInput.disabled.opacity || props.theme.global.control.disabled.opacity};
    cursor: default;
    `}
`;
const InputCurrency = /*#__PURE__*/forwardRef(({
  prefix,
  onValueChange,
  onChange,
  decimalLimit,
  maxLength,
  allowDecimals,
  ...rest
}, ref) => {
  const {
    setFieldValue
  } = useFormikContext() || {};
  const theme = useContext(ThemeContext);
  const {
    maxLength: themeMaxLength,
    allowDecimals: themeAllowDecimals
  } = theme?.currencyInput || {};
  return /*#__PURE__*/React.createElement(StyledInput, _extends({}, rest, {
    ref: ref,
    prefix: prefix,
    decimalsLimit: decimalLimit,
    onValueChange: (value, name) => {
      if (setFieldValue) setFieldValue(name, value);
      if (onValueChange) onValueChange(value, name);
    },
    maxLength: maxLength || themeMaxLength,
    allowDecimals: allowDecimals ?? themeAllowDecimals
  }));
});
InputCurrency.defaultProps = {
  prefix: '$',
  decimalLimit: 2,
  maxLength: undefined
};
InputCurrency.propTypes = {
  name: PropTypes.string,
  prefix: PropTypes.string,
  value: PropTypes.any,
  onValueChange: PropTypes.func,
  onChange: PropTypes.func,
  decimalLimit: PropTypes.number,
  maxLength: PropTypes.number,
  allowDecimals: PropTypes.bool
};
InputCurrency.displayName = 'CurrencyInput';
export default InputCurrency;